import { useHttpClient } from "@allwyn/utils/http-clients/use-http-client";
import { OnlineGameDetail } from "../model/online-game-detail";

const httpClient = useHttpClient();
httpClient.defaults.baseURL = "/api/casino";

export namespace CasinoApi {
    export const getGameDetail = async (gameId: string, withAbTest: boolean): Promise<OnlineGameDetail> => {
        const response = await httpClient.get<OnlineGameDetail>(`/game/${gameId}?withAbTest=${withAbTest}`);
        return response.data;
    };
}
